var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-name-header d-flex align-items-center pl-3"},[_c('img',{attrs:{"src":require("../assets/Images/optionsmodal/backarrow.svg"),"alt":""},on:{"click":function($event){return _vm.$emit('go-back')}}}),_c('h5',{staticClass:"fs-18 fw-500 font-lato color-white ml-2 my-0"},[_vm._v(" "+_vm._s(_vm.labeltext)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }